// Fired after any change to the « Mise en route » so the sidebar's progress
// entry refreshes without a page reload.
export const ONBOARDING_EVENT = 'una:onboarding';

export const notifyOnboardingChanged = () => window.dispatchEvent(new Event(ONBOARDING_EVENT));
